import type { BFFArticleBodyElement } from "@src/app/types/bff";
import cx from "classnames";

import ArticleAnnotation from "./components/ArticleAnnotation";

export default function ArticleImageCaption({
  element,
  isLightbox = false,
}: {
  element: BFFArticleBodyElement["image"];
  isLightbox?: boolean;
}) {
  if (!element.caption && !element.credit) return null;

  return (
    <figcaption
      className={cx(
        `text-label-2 text-left font-bold`,
        isLightbox ? "text-primary-on-dark m-4" : "text-tertiary mt-3",
      )}
    >
      <ArticleAnnotation
        value={element.caption}
        annotations={element.captionAnnotations}
      />

      {element.credit ? (
        <>
          <span> </span>
          (
          <ArticleAnnotation
            value={element.credit}
            annotations={element.creditAnnotations || []}
          />
          )
        </>
      ) : null}
    </figcaption>
  );
}
